export default __webpack_public_path__ + "static/media/feature-videos.602ea0f5.svg";